// extracted by mini-css-extract-plugin
module.exports = {"buttons":"e3afc254ff--buttons--nU07r","button":"e3afc254ff--button--zJMde"};